export const PRESET_DATE = {
    LAST_12_MONTHS: "last_12_Months",
    LAST_6_MONTHS: "last_6_Months"
}
export const RATER_GROUPS = [
    { value: 'self', label: 'Self' },
    { value: 'manager', label: 'Manager' },
    { value: 'direct report', label: 'Direct Report' },
    { value: 'peer', label: 'Peer' },
    {
        label: "Team Member", value: "team member"
    },
    {
        label: "Client", value: "client"
    },
    {
        label: "Cross-functional Partners", value: "cross-functional partner"
    },
    { value: 'other', label: 'Other' },
]   